import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 1,
        backgroundColor: theme.palette.secondary.light,
        borderTop: "0px",
        position: "fixed",
        bottom: 0,
        width: "100%",
        zIndex: "50",
      })}
    >
      <Typography variant="body2" color="text.secondary">
        &copy; {new Date().getFullYear()} TAGITStore. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
